export default {
  messageInputPlaceholder: 'Enviar mensagem',
  sendAMessage: 'Enviar uma mensagem',
  noMessages: 'Nenhuma novidade no momento',
  conversationNotFound: 'Conversa não encontrada',
  initFailed: 'Falha ao inicializar conversa',
  cannotGetReceiverInfo: 'Não é possível obter informações do destinatário',
  sendFailed: 'Falha ao enviar mensagem',
  newMessages: '{count} nova(s) mensagem(ns)',
  error: {
    messageSaveFailed: 'Falha ao salvar mensagem',
    messageHandleFailed: 'Falha ao processar mensagem',
  },
  message: {
    unsupported: '[Este tipo de mensagem ainda não é suportado]',
  },
}
